<template>
    <div>
        <div class="mainTitle text-center mt-4 mb-3">
            <h3 class="uppercase mb-4">{{$t('bankDetails')}}</h3>
            <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
            <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
        </div>
        <div class="CustomBlockWidth inMiddle-area whitebox p-4">  
            <div class="bankDetail">
                <div class="singleArea">
                    <div class="form-group field-wrapper">
                        <input placeholder=" " type="text" name="bank_name" class="float-field form-control" v-model="bank_name"  v-validate="{ required: true }" :class="{ 'is-invalid': submitted && errors.has('bank_name') }" ref="bank_nameInput" >
                        <label for="username" class="float-label">{{$t('bankName')}}</label>
                    </div>
                </div>
                <div class="twoBlock d-flex w-100">
                    <div class="form-group field-wrapper">
                        <input placeholder=" " type="text" name="micr" class="float-field form-control" v-model="micr"  v-validate="{ required: true }" :class="{ 'is-invalid': submitted && errors.has('micr') }" ref="micrInput" >
                        <label for="username" class="float-label">{{$t('MicrCode')}}</label>
                    </div>
                    <div class="form-group field-wrapper">
                        <input placeholder=" " type="text" name="account_no" class="float-field form-control" v-model="account_no"  v-validate="{ required: true }" :class="{ 'is-invalid': submitted && errors.has('account_no') }" ref="account_noInput" >
                        <label for="username" class="float-label">{{$t('IBANNumber')}}</label>
                    </div>
                </div>
                <div class="twoBlock d-flex w-100">
                    <div class="form-group field-wrapper">
                        <input placeholder=" " type="text" name="ifsc" class="float-field form-control" v-model="ifsc"  v-validate="{ required: true }" :class="{ 'is-invalid': submitted && errors.has('ifsc') }" ref="ifscInput" >
                        <label for="username" class="float-label">{{$t('ifscSwiftBic')}}</label>
                    </div>
                    <div class="form-group field-wrapper">
                        <input placeholder=" " type="text" name="username" class="float-field">
                        <label for="username" class="float-label">{{$t('currency')}}</label>
                    </div>
                </div>
                <div class="singleArea">
                    <div class="form-group field-wrapper">
                        <input placeholder=" " type="text" name="bank_address" class="float-field form-control" v-model="bank_address"  v-validate="{ required: true }" :class="{ 'is-invalid': submitted && errors.has('bank_address') }" ref="bank_addressInput" >
                        <label for="username" class="float-label">{{$t('bankAdd')}}</label>
                    </div>
                </div>
                <div class="col-12 p-0">
                    <div class="submitButton w-100 mt-2 text-center">
                        <a href="javascript:void(0)" class="prism_btn btn_sm w-150" @click="submit()">{{$t('Save')}}</a>
                    </div>
                </div>
            </div> 
        </div>
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'add-bank',
        mixins: [fxViewMixins],
        data() {
            return {
                account_no : '',
                bank_name : '',
                ifsc : '',
                micr : '',
                bank_address : '',
                submitted : false,
				pageLoader : false,
				response_msg : '',
				msg_type : ''
            }
        },
        methods:{
            submit(){
                const _that = this
                _that.submitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                'account_no' : _that.account_no,
                                'bank_name' : _that.bank_name,
                                'ifsc' : _that.ifsc,
                                'micr' : _that.micr,
                                'bank_address' : _that.bank_address
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runAddBank(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/bank/bank.vue